import { render, staticRenderFns } from "./ObjectCardRelated.vue?vue&type=template&id=13ca7495&scoped=true&"
import script from "./ObjectCardRelated.vue?vue&type=script&lang=js&"
export * from "./ObjectCardRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca7495",
  null
  
)

export default component.exports